import React, { useContext, useEffect, useState } from 'react'
import { AccountContext } from '../../../contexts/AccountContext'
import { toast } from 'react-toastify';
import { apiV1 } from '../../../lib/axios';
import { BsCreditCard2Front, BsInfoCircleFill } from 'react-icons/bs';
import ReactModal from 'react-modal';
import { CurrencyInput } from 'react-currency-mask';

const CreditLimitModal = ({ isOpen, onClose, card, setCardList }) => {
  const { avaliableBalance, getBalance } = useContext(AccountContext);
  const [loading, setLoading] = useState(false);
  const [limite, setLimite] = useState(0);
  const [error, setError] = useState('');

  const getAccountBalance = async () => {
    setLoading(true);
    await getBalance();
    setLoading(false);
  };

  const handleOnChange = (_, originalValue) => {
    setLimite(originalValue);
    setError('');
    if (!originalValue) {
      setError('O valor do limite não pode ser vazio.');
      return;
    }
    if (originalValue > avaliableBalance) {
      setError('O valor do limite não pode ser maior que o saldo disponível na conta.');
      return;
    }
  }

  const addCreditLimit = async () => {
    await apiV1
      .post('/cards/credit-limit', {
        id: card.id,
        creditLimit: limite,
        lastFour: card.lastFour,
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  }

  const handleOnSubmit = async () => {
    try {
      setLoading(true);
      await addCreditLimit();

      toast.success('Limite de crédito adicionado com sucesso!');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error('Erro ao adicionar limite de crédito:', error);
      toast.error('Erro ao adicionar limite de crédito');
    } finally {
      setLoading(false);
    }
  }

  const isButtonDisabled = () => {
    if (loading) return true;
    if (!limite) return true;
    if (limite > avaliableBalance) return true;
    return false;
  }

  useEffect(() => {
    getAccountBalance();
  }, []);
  return (
    <ReactModal
      isOpen={isOpen}
      className="change-modal"
      overlayClassName="overlay-change-password-modal"
    >
      <div className="modal show d-block">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-bottom">
              <h5 className="modal-title d-flex align-items-center">
                <BsCreditCard2Front className="me-2 text-success" />
                Adicionar Limite
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body p-4">
              <div className="row mb-4">
                <div className="col-6">
                  <p className="text-muted small mb-1">Cartão final</p>
                  <p className="fs-5 fw-medium">{card?.lastFour}</p>
                </div>
                <div className="col-6 text-end">
                  <p className="text-muted small mb-1">Limite atual</p>
                  <p className="fs-5 fw-medium text-success">R$ {card?.creditLimit}</p>
                </div>
              </div>

              <div className="mb-4">
                <label htmlFor="creditLimit" className="form-label fw-medium">
                  Quanto deseja adicionar?
                </label>
                <div className="input-group">
                  <span className="input-group-text">R$</span>
                  <CurrencyInput
                    id="creditLimit"
                    value={limite}
                    hideSymbol
                    onChangeValue={handleOnChange}
                    placeholder="0.00"
                    className="form-control"
                  />
                </div>
                <span className="text-danger small">{error}</span>
                <div className="d-flex justify-content-between mt-2">
                  <span className="text-muted small">Saldo disponível</span>
                  <span className="small fw-medium">R$ {avaliableBalance}</span>
                </div>
              </div>

              {/* Aviso */}
              <div className="alert alert-info d-flex align-items-center">
                <BsInfoCircleFill className="me-2 flex-shrink-0" />
                <div className="small">
                  O valor será debitado diretamente do saldo da sua conta.
                </div>
              </div>
            </div>

            <div className="modal-footer bg-light">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={onClose}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={isButtonDisabled() ? null : handleOnSubmit}
                disabled={isButtonDisabled()}
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      </div>
    </ReactModal>
  )
}

export default CreditLimitModal
